import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Initialize Facebook Pixel manually
    if (typeof window !== 'undefined') {
      // Create fbq function if it doesn't exist
      if (!window.fbq) {
        window.fbq = function () {
          // @ts-ignore
          window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
        };
        // @ts-ignore
        if (!window._fbq) window._fbq = window.fbq;
        // @ts-ignore
        window.fbq.push = window.fbq;
        // @ts-ignore
        window.fbq.loaded = true;
        // @ts-ignore
        window.fbq.version = '2.0';
        // @ts-ignore
        window.fbq.queue = [];
      }
      // Load the Facebook Pixel script
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      // Initialize the pixel
      window.fbq('init', '1119732203535463');
      window.fbq('track', 'PageView');
    }
  }, []);
  return null;
}